<template>
  <div class="row">
      <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
        <div class="card mb-25 border-0 rounded-0">
          <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
              <h4 class="position-relative text-black fw-bold mb-10">Détails de la place</h4>
              <router-link to="/liste-place" 
              class=" btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow  lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Retour</router-link>
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td>Code :</td>
                  <td>{{ element?.code }} </td>
                </tr>
                <tr>
                  <td>Marché:</td>
                  <td> {{ element?.marche?.libelle }} </td>
                </tr>
                <tr>
                  <td>Type :</td>
                  <td> {{ element?.type?.type?.libelle }} </td>
                </tr>
                <tr>
                  <td>Loyer de base :</td>
                  <td> {{ element?.loyerBase }} </td>
                </tr>
                <tr>
                  <td>Statut :</td>
                  <td> 
                    <span class="badge" :class=" (element?.statut == 1) ? 'bg-danger' : 'bg-success'">
                        {{ element?.statut == 0 ? 'Non Occupé' : 'Occupé' }} 
                    </span>
                  </td>
                </tr>
                
              </tbody>
            </table>
            
            <h5 class="mt-4">Historique des contrats sur cette place</h5>
            <table class="table">
              <thead>
                <tr>
                  <th>Statut Contrat</th>
                  <th>Reference Contrat</th>
                  <th>Matricule Usager</th>
                  <th>Nom complet</th>
                  <th>Téléphone</th>
                </tr>
              </thead>
              <tbody> 
                <tr v-for="ele in element?.contrats" :key="ele.id">
                  <td> 
                    <span 
                         class="badge"
                        :class=" (ele.statut == 0) ? 'bg-secondary' : (ele.statut == 1 ? 'bg-ingfo' : 'bg-danger') ">
                        {{ (ele.statut == 0) ? 'En attente' : (ele.statut == 1 ? 'Actif' : 'Résiliers') }}
                    </span> 
                  </td>
                  <td>{{ ele?.reference }}</td>
                  <td>{{ ele?.usager?.matricule }}</td>
                  <td>{{ ele?.nomMarchand }}</td>
                  <td>{{ ele?.usager?.numtel }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { error, format_date } from "@/utils/utils";
import { useRoute } from "vue-router";
import { Place } from "@/models/Place";

export default defineComponent({
name: "ViewPlace",
setup: () => {
  const route = useRoute();
  const element = ref<Place | null>(null);

  function getElement(id: string) {
    return ApiService.get("/places", id)
      .then(({ data }) => {
        element.value = data.data; 
      })
      .catch(({ response }) => {
        error(response.data.message);
      });
  } 

  onMounted(() => {
    const id = route.params.id as string;
    getElement(id);
  });

  return { 
    element,
    getElement,
    format_date,
  };
},
});
</script>
